module.exports = __webpack_public_path__ + "img/fml-logo.d0e87dcb.png";